export default {
  /*
   * create() inicia una desactivación de Qr
   */
  create(id) {
    return Vue.http.post(`passenger/qr_deactivation/${id}`).then(response => response.data.data)
  }
}
